const { createSlice } = require("@reduxjs/toolkit");
const initialState = {
    paiements: [],
    paiement: null,
    loading: false,
    error: null,
};

const paiementsSlice = createSlice({
    name: "paiements",
    initialState,
    reducers: {
        setPaiementsState: (state, { payload }) => {
            state.paiements = payload;
        },
        setPaiementState: (state, { payload }) => {
            state.paiement = payload;
        },
        setLoading: (state, { payload }) => {
            state.loading = payload;
        },
        setError: (state, { payload }) => {
            state.error = payload;
        },
    },

});

export const { setPaiementsState, setPaiementState, setLoading, setError } =
    paiementsSlice.actions;

export default paiementsSlice.reducer;
